import React from "react";

const PayoutTableSkeleton = () => {
  return (
    <div className="animate-pulse space-y-6">
      <div className="card-board overflow-hidden">
        <div className="bg-brand-charcoal px-6 py-4">
          <div className="h-6 bg-brand-line rounded w-1/3 mb-2"></div>
          <div className="h-4 bg-brand-line rounded w-1/2"></div>
        </div>
        <div className="p-6">
          <div className="h-6 bg-brand-cream rounded w-1/4"></div>
        </div>
      </div>

      <div className="card-board overflow-hidden">
        <table className="min-w-full">
          <thead className="bg-brand-charcoal">
            <tr>
              <th className="px-6 py-3 text-center" colSpan={6}>
                <div className="h-6 bg-brand-line rounded w-1/2 mx-auto"></div>
              </th>
            </tr>
            <tr>
              <th className="px-6 py-3"></th>
              <th className="px-6 py-3"></th>
              {[1, 2, 3, 4].map((i) => (
                <th key={i} className="px-6 py-3 text-center">
                  <div className="h-4 bg-brand-line rounded w-12 mx-auto"></div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[1, 2, 3, 4].map((row) => (
              <tr
                key={row}
                className={row % 2 === 0 ? "bg-white" : "bg-brand-cream/60"}
              >
                <td className="px-6 py-4 text-center">
                  <div className="h-4 bg-brand-cream rounded w-8 mx-auto"></div>
                </td>
                {[1, 2, 3, 4].map((col) => (
                  <td key={col} className="px-6 py-4 text-center">
                    <div className="h-4 bg-brand-cream rounded w-16 mx-auto"></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PayoutTableSkeleton;
